export const SEED_LENGTH = 8;
export const MIN_GRID_LENGTH_LEVER = 0;
export const MAX_GRID_LENGTH_LEVER = 5;
export const MIN_HORIZONTAL_LEVER = 0;
export const DEFAULT_HORIZONTAL_LEVER = 0;
export const MAX_HORIZONTAL_LEVER = 68;
export const MIN_DIAGONAL_LEVER = 0;
export const DEFAULT_DIAGONAL_LEVER = 0;
export const MAX_DIAGONAL_LEVER = 29;
// export const PERIOD = 2353 * 2; // ableton samples
export const PERIOD = 4500; // custom samples
export const INNER_SHAPES_KEYS = ['cube', 'cubeSphere', 'cubeDiamond', 'sphere'];
export const INNER_SHAPES = {
  square: 'cube',
  squareCircle: 'cubeSphere',
  squareDiamond: 'cubeDiamond',
  circle: 'sphere',
};

export const TOKEN_TYPES = {
  original: 'original',
  print: 'print',
};

export const PALETTE_NAMES = [
  '0.- Australian sunset',
  '1.- Ocean',
  '2.- Piet',
  '3.- Neon',
  '4.- Neon II',
  '5.- Cherry Blossom',
  '6.- Pastel Sunrise',
  '7.- Tropical',
  '8.- Beach',
  '9.- Vulcano',
  '10.- Parrot',
  '11.- Mona Lisa',
];

export const MAX_ORIGINALS = 27;

export enum REQUEST_STATUS {
  idle = 'idle',
  loading = 'loading',
  error = 'error',
  success = 'success',
}

export const POLYGON_ETH_CONTRACT_ADDRESS = '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619';

export const GRID_BREAKPOINTS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
};

export const FUTURA_PALETTES = [
  {
    name: 'Neon',
    layers: ['#f20089', '#db00b6', '#d100d1', '#b100e8', '#6a00f4'],
    description: 'Neon embodies gas-hued embers that overpower the darkness of night.',
  },
  {
    name: 'Terminal',
    layers: ['#92e5a1', '#beff0a', '#80ce87', '#22b455', '#204829'],
    description:
      'Terminal represents in greens a bustling hub, an intersection of sounds that can transport us wherever we want to go.',
  },
  {
    name: 'Clouds',
    layers: ['#5688fe', '#6a98ff', '#ccdbfd', '#ffb340', '#ff9d89'],
    description:
      'Clouds embodies the ethereal nature of the sky, the sun, and the clouds that cascade before our vision.',
  },
  {
    name: 'Sakura',
    layers: ['#fc856f', '#f7674a', '#ff320c', '#f79f56', '#f99a49'],
    description: 'Our interpretation of the Cherry Blossom, with a bright, modern twist.',
  },
  {
    name: 'Atlantis',
    layers: ['#1e6091', '#168aad', '#168aad', '#76c893', '#99d98c'],
    description:
      'A lost civilization, sunken beneath the waves, but still exerting its mystery to this day.',
  },
  {
    name: 'Ares',
    layers: ['#ffd361', '#ffba08', '#f48c06', '#e85d04', '#dc2f02'],
    description:
      'A fiery palette to represent the God of War and the boisterous, chaotic nature of battle.',
  },
  {
    name: 'Toothpaste',
    layers: ['#e63946', '#a8dadc', '#457b9d', '#1d3557', '#ee6352'],
    description:
      'For those that enjoy their music non-standard, Toothpaste embodies the search for hidden details that are all too easily initially overlooked.',
  },
  {
    name: 'Ultraviolet',
    layers: ['#fdc500', '#ffee32', '#ffd500', '#5c0099', '#3d0066'],
    description: 'See music through a different lens, and Futura is the result!',
  },
  {
    name: 'Metal',
    layers: ['#8d99ae', '#edf2f4', '#ef233c', '#d90429', '#7b0217'],
    description:
      'Metal represents the hard/soft dichotomy of this base element, and the fiery forge through which all must pass.',
  },
  {
    name: 'Sashimi',
    layers: ['#f8ad9d', '#ffdab9', '#fbc4ab', '#f4978e', '#f08080'],
    description: 'Sashimi… delicate and tender, just like the dish.',
  },
  {
    name: 'Bright',
    layers: ['#f86624', '#ea3546', '#662e9b', '#43bccd', '#5dd39e'],
    description:
      'This palette contains the full spectrum, which embodies the endless potential of the Futura. Anything is possible!',
  },
  {
    name: 'Chill',
    layers: ['#faa275', '#ffed66', '#ff5e5b', '#00cecb', '#25a18e'],
    description: 'Reminds you of a relaxing day at the beach.',
  },
  {
    name: 'Macaw',
    layers: ['#ff595e', '#ffca3a', '#8ac926', '#1982c4', '#6a4c93'],
    description: 'Vibrant and contrasting flavours, exotic in its sonic and visual potential.',
  },
  {
    name: 'Nebula',
    layers: ['#6930c3', '#5390d9', '#48bfe3', '#72efdd', '#06d6a0'],
    description:
      'Echoes of the vast and infinite, the Nebula palette points to the stars to offer us hope and wonder.',
  },
];

export const FUTURA_EFFECT_ATTRIBUTES = {
  laserEffect: 'Laser',
  lightFlickeringEffect: 'Light Flickering',
  lightPulseEffect: 'Light Pulse',
  lightWavesEffect: 'Light Waves',
  lightningEffect: 'Lightning',
  orbitingParticlesEffect: 'Orbiting Particles',
  shakingEffect: 'Shaking',
  spheresEffect: 'Spheres',
};

export const FUTURA_ATTRIBUTES = {
  generation: 'Generation',
  bpm: 'Bpm',
  colorPalette: 'Color Palette',
  noteShape: 'Note Shape',
  twists: 'Twists',
  distortion: 'Distortion',
  mobius: 'Möbius',
  ...FUTURA_EFFECT_ATTRIBUTES,
};

export const FUTURA_MINT_MIX_GAS_LIMIT = 1500000;

export const AUDIO_OPTIONS = {
  soundFontURLs: ['ar://uajj_NGBdzcWdCznORs9axxez5IrQBkvMhkk6WkQ6Yg'],
};

export enum FuturaDropStage {
  SETUP = 0, // Default: for admin configuring
  MIXES_AVAILABLE = 1, // Redemption of 1155s are open for minting Mixes
  SALE_COMPLETE = 2, // Mixes are no longer available
  REMIXING_ENABLED = 3, // Remixing is now live
}

export const GalleryView = {
  ALL: 'all',
  OWNED: 'owned',
};

export const TRAITS_MEDIA_FILES = {
  cover: 'https://eulerbeats.infura-ipfs.io/ipfs/QmZZkXu4Zfff4ddsgpPTGXPYjmC4HPVxDSAmmQHkordvVm',
  effects: {
    laser: 'https://eulerbeats.infura-ipfs.io/ipfs/Qmbapdd7RcHxjq4D8rKVa1iPdFvxNuxX1ph42q314MzYv6',
    particles:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmXvScUgcXHruL7tPAC9Cnn3QAdAt6kXBQALHuPsspcBNe',
    lightWave:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmVoteL1F44qSLUtJCgMaoeSbPTsDyRi6Gq6emYW3woHZR',
    lightning:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmNQXw2WXsxQN8s21jW5Gdx1XTahrwSR5m3Qy9qd2v2CaU',
    shake: 'https://eulerbeats.infura-ipfs.io/ipfs/QmWRWeTt9Pp7ncWXiWTupvBEriN18RcdDNHfmUi4rpZ4CW',
    flicker:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmRfL3H7XDnXwvHtXgjZPbQdL2c7ZsEDErN3fFt9ZSUPFx',
    lightPulse:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmZs4FQ71yFBx7AnaHU1U9NdmwF57EEMyW6Ldzo6m4nBTo',
    spheres:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmcLDPZrnsDZZF1bYXgpn2tFzmCDYQ4W5wJcmiGdLkXHAR',
  },
  palettes: {
    Ares: 'https://eulerbeats.infura-ipfs.io/ipfs/QmbZcWHPLe9HLBdVfCSZDRxxiMYq51GEG4xafiEYKaw7so',
    Atlantis:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmaEed8jAPbHmb9Cm8VPN1D4LWjtki2RTeF7CvkuAY68Rg',
    Bright: 'https://eulerbeats.infura-ipfs.io/ipfs/Qmej6XDUEWwhQ2BJScQ78f6eRqehDia5Ebzv9XCsMPnabt',
    Chill: 'https://eulerbeats.infura-ipfs.io/ipfs/QmeVGvWHJGTmNyXZbtzviWtMnzB4Tn8S2TqZP6Evig63Qn',
    Clouds: 'https://eulerbeats.infura-ipfs.io/ipfs/QmTw4v28cqan4xBhKSELqQg9af6xorR35a3zwN7c843vCm',
    Macaw: 'https://eulerbeats.infura-ipfs.io/ipfs/QmVa61PFyJ9fh58vqrdS3ePUFPUhx4CUyEW1GEty6PVacp',
    Metal: 'https://eulerbeats.infura-ipfs.io/ipfs/QmbT1DYT4C2gJutmjPREEeXJpQtiVp6UFe7JZLoZ5kn2g8',
    Nebula: 'https://eulerbeats.infura-ipfs.io/ipfs/QmNSsAAdG1hJ8WEbW3g48Vd2zgwJqgrmtWdKwUDrapZ2q5',
    Neon: 'https://eulerbeats.infura-ipfs.io/ipfs/Qma2oknvApGTDNDn51Hyx3rTci91W43P39i4frznoYkGcF',
    Sakura: 'https://eulerbeats.infura-ipfs.io/ipfs/QmengpDW3fDJJ7ktYt9CDhq92vZ8XVUMtRjNK8vEPj93EK',
    Sashimi:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmW2U5w3cjytP9VaFQjEgDc9Qh3DCD4u3GRksRQ9QSR3FE',
    Terminal:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmQ4BFAamLQoD2bC88qbub1YvEhh4ksqosSpAPnzjV4KnL',
    Toothpaste:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmddGQs6qKKTdBBb84hnGEGC52SB56iZE86bbZ5HwTGZ5a',
    Ultraviolet:
      'https://eulerbeats.infura-ipfs.io/ipfs/Qmd22jG3MWfr9PKyRQuK45cF1jYTaSp3jwGd9EahdDCq6G',
  },
  twists: {
    1: 'https://eulerbeats.infura-ipfs.io/ipfs/QmbnyMG4vuRSA5AqDvhVDtsy2K1GwbCBgnUshi9burgZAy',
    2: 'https://eulerbeats.infura-ipfs.io/ipfs/QmfYBPCqvdhGimXwS4vdXvL32DcmykEnzLgNAvQ1W6HJ2b',
    3: 'https://eulerbeats.infura-ipfs.io/ipfs/QmTNXdQvtxw29BToHdm5xi814dNLCdihUpN74b95CT2vG6',
    5: 'https://eulerbeats.infura-ipfs.io/ipfs/Qmf8urdoJ6F6kUHteNEPqYEPvey42SMVrSsMi85jRr7ep3',
    distortion:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmdCje73NCWB5TxNYcTzHadfeqtxsnPcj8LZQ1Y42VbHqP',
  },
  noteShapes: {
    line: 'https://eulerbeats.infura-ipfs.io/ipfs/QmYCRPrtavh38QHkVCdSiHcQXNfyPW7oLpjmhaEmFA9f9g',
    square: 'https://eulerbeats.infura-ipfs.io/ipfs/QmWCv3HjeTLUTD3xXVDn6eParSZVtsZqhakGGskLePrtn4',
    triangle:
      'https://eulerbeats.infura-ipfs.io/ipfs/QmTvZXrojhKXk2rWBQZCxqHr2zNS756jgbd1n6Bbj4Zw1h',
  },
};
